export const APISERVERURL='https://api.puapp.nirupan.org'
